import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import Footer from "../../components/Footer";
import MyReportsMain from "./MyReportsMain";

const MyReports = () => {
  return (
    <>
      <HeaderFour headerClass="it-header-area-two" />
      <MyReportsMain />
      <Footer />
    </>
  );
};

export default MyReports;
